<template>
    <div class="bind-box">
        <van-cell>
            <p style="text-align: center">当前账号未绑定微信，未授权之前，会影响下面功能</p>
        </van-cell>

        <van-cell>
            <div style="width: 3.42rem;margin: auto">
                <p>1. 微信下单推送通知</p>
                <p>2. 红包优惠领取</p>
            </div>
        </van-cell>

        <van-button
                class="bind-button "
                type="primary"
                size="small"
                @click.stop="confirm">确认授权
        </van-button>
    </div>
</template>

<script>
    export default {
        name: "WxBind",
        methods: {
            confirm() {
                this.wxAuth()
            },
            async wxAuth() {
                try {
                    let isWxLogin = window.navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1
                    if (!isWxLogin) {
                        this.$toast({
                            message: '请使用微信内置浏览器授权',
                            duration: 1000
                        })
                        return
                    }
                    let params = {
                        params: {
                            wechatMark: this.$wechatMark,
                            callback: this.$callbackPage
                        }
                    }
                    this.$axios.get('weixin/getCodeUrl', params).then(res => {
                        window.location.href = res.data.data
                    })
                    this.$toast.clear()
                } catch (err) {
                    this.$toast({
                        message: err.data.msg,
                        duration: 1000
                    })
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .bind-box {
        background-color: #ffffff;
        padding-top: 3rem;
        position: relative;

        p{
            font-size: 0.36rem;
        }
        span{
            font-size: 0.36rem;
        }
    }

    .bind-button {
        display: inline-block;
        width: 80%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%);
        height: 1.33rem;
    }

</style>
